import layoutApi from '@/api/layout'

const state = () => ({
  mini: JSON.parse(localStorage.getItem('mini')),
  darkTheme: JSON.parse(localStorage.getItem('darkTheme')),
  currentRouteTitle: '',
  sidebarNotifications: {}
})

const getters = {
  currentRouteTitle (state) {
    return state.currentRouteTitle
  },
  mini () {
    return JSON.parse(localStorage.getItem('mini'))
  },
  darkTheme () {
    return JSON.parse(localStorage.getItem('darkTheme'))
  }
}

const actions = {
  toggleMini ({ commit }) {
    commit('toggleMini')
  },
  toggleDarkTheme ({ commit }, value) {
    commit('toggleDarkTheme', value)
  },
  setTitle ({ commit }, title) {
    commit('setCurrentRouteTitle', title)
  },
  updateSidebarNotifications({ commit }, data) {
    commit('setSidebarNotifications', data)
  },
  async getSidebarNotifications ({ commit }) {
    const result = await layoutApi.getNotifications()
    commit('setSidebarNotifications', result.data)
  }
}

const mutations = {
  toggleMini (state) {
    const mini = JSON.parse(localStorage.getItem('mini'))
    localStorage.setItem('mini', !mini)
    state.mini = !mini
  },
  toggleDarkTheme (state, value) {
    localStorage.setItem('darkTheme', value)
    state.darkTheme = value
  },
  setCurrentRouteTitle (state, title) {
    state.currentRouteTitle = title
  },
  setSidebarNotifications (state, data) {
    state.sidebarNotifications = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}